/** Chave legada em `configuracoes` (Xpro antigo). */
export const EXTERNAL_REGISTRATION_CONFIG_KEY = "urlbasebtnidinterno";

export function normalizeInternalId(value) {
  if (value == null) return "";
  return String(value).trim();
}

/** Monta a URL externa: base configurada + id_interno do cliente. */
export function buildExternalRegistrationUrl(baseUrl, idInterno) {
  const base = String(baseUrl || "").trim();
  const id = normalizeInternalId(idInterno);
  if (!base || !id) return null;
  return `${base}${id}`;
}

export function canShowExternalRegistration(baseUrl, idInterno) {
  return Boolean(buildExternalRegistrationUrl(baseUrl, idInterno));
}
